
import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import { selectClothIsInfo } from '../../Selectors/Master/ItemSelectors';
import { fetchClothIssueInfo } from '../../../Store/PHPSlice/Cutting/clothIssue';
import { fetchclothstklump } from '../../../Store/PHPSlice/clothStock';
import { selectClothstklumplist } from '../../Selectors/UploadStock/ReadyMSelector';


const ClothIssueReturn = () => {
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        dt: '',
        empNm: '',
        ordType: '',
        soId: '',
        sono: '',
        totMtr: '',
        challanId: ''
    });
    const dispatch = useDispatch();
    const [lumpRows, setLumpRows] = useState([]);
    const [lumpTotMtr, setLumpTotMtr] = useState(0);
    const [usedTotMtr, setUsedTotMtr] = useState(0);
    const [balTotMtr, setBalTotMtr] = useState(0);
    const [baleNo, setBaleNo] = useState('');
    const [baleData, setBaleData] = useState({});
    const [openLump, setOpenLump] = useState(false);
    const clIssInfo = useSelector(selectClothIsInfo);
    const lumplist = useSelector(selectClothstklumplist);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed
    useEffect(() => {
        dispatch(fetchClothIssueInfo(Id))
    }, [Id, dispatch]);

    useEffect(() => {
        if (lumplist?.data4?.length > 0) {
            const data = JSON.parse(JSON.stringify(lumplist.data4));
            const updatedData = data.map((item) => {
                return {
                    ...item, // Keep all existing properties
                    usedmtr: item.bmtr, // Add new property and value
                    balmtr: 0
                };
            });
            setLumpRows(updatedData);
            const totmtr = data.reduce((acc, lump) => acc + parseInt(lump.bmtr), 0);
            setLumpTotMtr(totmtr);
            setUsedTotMtr(totmtr);
        }
    }, [lumplist])

    useEffect(() => {
        if (clIssInfo?.data) {
            const item = clIssInfo?.data;
            setFormData(prev => ({
                ...prev,
                dt: item?.dt,
                empNm: item?.empNm,
                ordType: item?.ordType,
                soId: item?.soId,
                sono: item?.sono,
                totMtr: item?.totMtr,
                challanId: item?.challanId
            }));
        }
    }, [clIssInfo]);

    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };

    const handleViewClick = (id, baleNo, ID) => {
        // window.open(`/ClothIssueLumpsView/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
        setOpenLump(true);
        const data = baleData[baleNo];
        if (data?.length > 0) {
            setLumpRows(data);
            const totmtr = data.reduce((acc, lump) => acc + parseInt(lump.bmtr), 0);
            const usedtotmtr = data.reduce((acc, lump) => acc + parseInt(lump.usedmtr), 0);
            const baltotmtr = data.reduce((acc, lump) => acc + parseInt(lump.balmtr), 0);
            setLumpTotMtr(totmtr);
            setUsedTotMtr(usedtotmtr);
            setBalTotMtr(baltotmtr);
        } else {
            dispatch(fetchclothstklump(id));
        }
        setBaleNo(baleNo);
        console.log(ID);
    };

    const handleUpdateLump = () => {
        setBaleData((prev) => {
            // Check if the current baleNo exists as a key in the state
            if (baleNo && prev.hasOwnProperty(baleNo)) {
                return {
                    ...prev,
                    [baleNo]: lumpRows, // Dynamically update the specific baleNo key
                };
            }

            // If baleNo does not exist, return the state unchanged
            return {
                ...prev,
                [baleNo]: lumpRows, // Dynamically update or create the baleNo key
            };
        });
        setBaleNo('');
        setLumpRows([]);
        setLumpTotMtr(0);
        setUsedTotMtr(0);
        setBalTotMtr(0);
        setOpenLump(false);
    }

    const handleLumpMtr = (index, value) => {
        const updateLumps = [...lumpRows];
        const inputValue = parseFloat(value) || 0;
        const givenMtr = parseFloat(updateLumps[index]?.mtr) || 0;
        updateLumps[index].usedmtr = inputValue > givenMtr ? givenMtr : inputValue;

        updateLumps[index].balmtr = inputValue > givenMtr ? 0 : givenMtr - inputValue;
        // Calculate the sum of all mtr values in the lumpRows array
        const totalMtr = updateLumps.reduce((sum, lump) => {
            // Ensure that mtr values are numeric and handle potential empty values
            const mtrValue = parseFloat(lump.mtr) || 0;
            return sum + mtrValue;
        }, 0);

        const usedtotmtr = updateLumps.reduce((sum, lump) => {
            // Ensure that mtr values are numeric and handle potential empty values
            const mtrValue = parseFloat(lump.usedmtr) || 0;
            return sum + mtrValue;
        }, 0);

        const baltotmtr = updateLumps.reduce((sum, lump) => {
            // Ensure that mtr values are numeric and handle potential empty values
            const mtrValue = parseFloat(lump.balmtr) || 0;
            return sum + mtrValue;
        }, 0);
        setLumpTotMtr(totalMtr);
        setLumpRows(updateLumps);
        setUsedTotMtr(usedtotmtr);
        setBalTotMtr(baltotmtr);
    };
    // console.log(clIssInfo?.data);
    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1% 0%', width: '100%' }} ref={componentRef}>

                        <h3 className='centered-heading'>Cloth Issue Return</h3>
                        <div className="dashed-line"></div>

                        {/* <table style={{ margin: '1% 5%', fontSize: '15px' }}>

                            <tbody>

                                <tr>
                                    <td style={{ width: '200px' }}>Master</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>{formData.empNm}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Date</td>
                                    <td>:</td>
                                    <td style={{ padding: ' 0.2% 1%', width: '150px' }} className='dark-color'>{formData.dt}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Order Type</td>
                                    <td>:</td>
                                    <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formData.ordType}</td>
                                    <td style={{ width: '200px' }}>Challan No.</td>
                                    <td>:</td>
                                    <td style={{ width: '25vw', padding: ' 0 1.5%' }}>{formData.challanId}</td>
                                </tr>

                                {formData.soId != '0' &&
                                    <tr>
                                        <td style={{ width: '200px' }}>SO No.</td>
                                        <td>:</td>
                                        <td style={{ width: '25vw', padding: ' 0 1.5%' }}>{formData.sono}</td>

                                    </tr>}

                                <tr>
                                    <td style={{ width: '200px' }}>Total Mtr.</td>
                                    <td>:</td>
                                    <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formData.totMtr}</td>
                                   
                                </tr>
                            </tbody>

                        </table> */}

                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableHead>
                                    <TableRow className='tbl-row'>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Item</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Cloth</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Bale</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Lump</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Mtr.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Total Mtr.</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Array.isArray(clIssInfo?.data?.item) && clIssInfo?.data?.item?.length > 0 ? clIssInfo?.data?.item?.map((item, index) => (
                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{index + 1}</TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.itemNm}</TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                {item?.info?.length > 0 ? item?.info?.map((inf, infIndex) => (
                                                    <div key={infIndex}>
                                                        {infIndex > 0 && <hr />}
                                                        {inf.clothNm}
                                                    </div>
                                                )) : null}
                                            </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                {item?.info?.length > 0 ? item?.info?.map((inf, infIndex) => (
                                                    <div key={infIndex}>
                                                        {infIndex > 0 && <hr />}
                                                        {inf.baleNo}
                                                    </div>
                                                )) : null}
                                            </TableCell>

                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                {item?.info?.length > 0 ? item?.info?.map((inf, infIndex) => (
                                                    <div key={infIndex}>
                                                        {infIndex > 0 && <hr />}
                                                        <button type='button' style={{ fontSize: '10px' }} className='add' onClick={() => handleViewClick(inf.baleId, inf.baleNo, inf.ID)}>info</button>
                                                    </div>
                                                )) : null}
                                            </TableCell>

                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                {item?.info?.length > 0 ? item?.info?.map((inf, infIndex) => (
                                                    <div key={infIndex}>
                                                        {infIndex > 0 && <hr />}
                                                        {inf.gMtr}
                                                    </div>
                                                )) : null}
                                            </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.totmtr}</TableCell>
                                        </TableRow>
                                    )) : null}
                                </TableBody>
                            </Table>
                        </TableContainer>

                    </div>

                    {openLump == true &&

                        <div>
                            <h3>Bale : {baleNo}</h3>
                            <table style={{ width: '100%' }}>
                                <thead>
                                    <tr>
                                        <th>Sr. No.</th>
                                        <th>Barcode</th>
                                        <th>Color</th>
                                        <th>Given Mtr</th>
                                        <th>Used Mtr</th>
                                        <th>Bal Mtr</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {lumpRows.map((lumpRow, lumpIndex) => (
                                        <>
                                            <tr key={lumpIndex}>
                                                <td>
                                                    {lumpIndex + 1}
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        placeholder="barcode"
                                                        value={lumpRow.barcode}
                                                        readOnly
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        placeholder="color"
                                                        value={lumpRow.color}
                                                        // onChange={(e) => handleLumpColor(
                                                        //     lumpIndex,
                                                        //     e.target.value
                                                        // )}
                                                        readOnly
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        placeholder="Given Mtr"
                                                        value={lumpRow.bmtr}
                                                        // onChange={(e) => handleLumpMtr(
                                                        //     lumpIndex,
                                                        //     e.target.value
                                                        // )}
                                                        readOnly
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        placeholder="Used Mtr"
                                                        value={lumpRow.usedmtr}
                                                        onChange={(e) => handleLumpMtr(
                                                            lumpIndex,
                                                            e.target.value
                                                        )}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        placeholder="Bal Mtr"
                                                        value={lumpRow.balmtr}
                                                    />
                                                </td>
                                            </tr>
                                        </>
                                    ))}
                                    <tr>
                                        <td> </td>
                                        <td> </td>
                                        <td>
                                            <span className="tot-lump">Total Mtr</span>
                                        </td>
                                        <td>
                                            <span className="tot-lump">{lumpTotMtr}</span>
                                        </td>
                                        <td>
                                            <span className="tot-lump">{usedTotMtr}</span>
                                        </td>
                                        <td>
                                            <span className="tot-lump">{balTotMtr}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <button type='button' className='add' onClick={handleUpdateLump} disabled={lumpRows.length === 0}>Update</button>
                        </div>
                    }
                </Paper>
            </Grid>
        </>
    );
};

export default ClothIssueReturn;
